export const getOrderProductPreQuery = (orderType) =>
  orderType === "TRANSFER" ? undefined : { status: "ACTIVE" };

export const isProductAllowedForOrderType = (productStatus, orderType) =>
  orderType === "TRANSFER" || !productStatus || productStatus === "ACTIVE";

export const isMpfProduct = (formValues) =>
  formValues?.productSnapShot?.category?.code === "MPF";

export const isIlasProduct = (formValues) =>
  formValues?.productSnapShot?.category?.code === "ILAS" ||
  formValues?.productCategory?.code === "ILAS" ||
  formValues?.product?.category?.code === "ILAS";

export const isInvestmentTransactionsProduct = (formValues) =>
  formValues?.productType?.investmentTransactions === true ||
  formValues?.productSnapShot?.type?.investmentTransactions === true ||
  formValues?.product?.type?.investmentTransactions === true;

export const isMortgageeHirePurchaseProduct = (formValues) =>
  formValues?.productType?.mortgageeHirePurchase === true ||
  formValues?.productSnapShot?.type?.mortgageeHirePurchase === true ||
  formValues?.product?.type?.mortgageeHirePurchase === true;

export const getOrderPolicyNumberLabel = (formValues) =>
  isInvestmentTransactionsProduct(formValues)
    ? "Account Number"
    : "Policy Number";
